import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=6c08f06c&scoped=true&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c08f06c",
  null
  
)

export default component.exports